export const environment = {
  production: true,
  baseHref: '',
  baseUrl: 'cheetah/api/',
  baseChirpUrl: 'chirp/api/',
  baseGoatUrl: 'goat/api/',
  releaseName: '2025-dockerfile-changes-626',
  buildNumber: 'd38a2ea0bf-',
};
